import React, { useState } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { EuiTabs, EuiTab } from '../../../../../src/components/tabs';
import { EuiErrorBoundary } from '../../../../../src/components/error_boundary';
import { EuiHorizontalRule } from '../../../../../src/components/horizontal_rule';
import { GuideSectionSnippets } from './guide_section_snippets';
import { GuideSectionExampleCode } from './guide_section_code';
import { GuideSectionPropsTable } from './guide_section_props_table';
import { EuiFlexGroup, EuiFlexItem } from '../../../../../src/components/flex';
export var GuideSectionExampleTabs = ({
  tabs,
  rightSideControl
}) => {
  const [selectedTabId, setSelectedTabId] = useState('');

  const onSelectedTabChanged = id => {
    if (id === selectedTabId) {
      setSelectedTabId('');
    } else {
      setSelectedTabId(id);
    }
  };

  const tabClasses = classNames('guideSectionTabs', {
    'guideSectionTabs--open': selectedTabId
  });

  const renderTabs = () => {
    return <EuiTabs size="s" display="condensed">
        {tabs.map((tab, index) => {
        const {
          displayName,
          code,
          name,
          props,
          snippets,
          ...rest
        } = tab;
        return <EuiTab {...rest} className="guideSectionTabs__tab" name={name} onClick={() => onSelectedTabChanged(name)} isSelected={name === selectedTabId} key={index}>
              {tab.displayName}
            </EuiTab>;
      })}
      </EuiTabs>;
  };

  const renderContent = () => {
    if (!selectedTabId) return null;
    const selectedTab = tabs.find(tab => tab.name === selectedTabId); // SNIPPET

    if (selectedTab && selectedTab.snippets) {
      return <EuiErrorBoundary>
          <EuiHorizontalRule margin="none" />
          <GuideSectionSnippets snippets={selectedTab.snippets} />
        </EuiErrorBoundary>; // SOURCE CODE BLOCK
    } else if (selectedTab && selectedTab.code) {
      return <EuiErrorBoundary>
          <EuiHorizontalRule margin="none" />
          <GuideSectionExampleCode code={selectedTab.code} />
        </EuiErrorBoundary>; // PROPS TABLE
    } else if (selectedTab && selectedTab.props) {
      const components = Object.keys(selectedTab.props);
      return components.map(component => <EuiErrorBoundary key={component}>
          <GuideSectionPropsTable key={component} componentName={component} component={selectedTab.props[component]} />
        </EuiErrorBoundary>);
    }
  };

  return <>
      <EuiFlexGroup className={tabClasses} responsive={false} wrap gutterSize="none" alignItems="center">
        <EuiFlexItem>{renderTabs()}</EuiFlexItem>
        <EuiFlexItem grow={false}>{rightSideControl}</EuiFlexItem>
      </EuiFlexGroup>
      {selectedTabId && renderContent()}
    </>;
};
GuideSectionExampleTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    isSelected: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    "aria-label": PropTypes.string,
    "data-test-subj": PropTypes.string,
    code: PropTypes.any,
    snippets: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.arrayOf(PropTypes.string.isRequired).isRequired]),
    props: PropTypes.any,
    displayName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired).isRequired,

  /** Renders any content to the right of the tabs (playground toggle) */
  rightSideControl: PropTypes.node
};

try {
  GuideSectionExampleTabs.__docgenInfo = {
    description: '',
    displayName: 'GuideSectionExampleTabs',
    methods: [],
    props: {
      tabs: {
        defaultValue: null,
        description: '',
        name: 'tabs',
        parent: undefined,
        required: true,
        type: {
          name: 'GuideSectionExampleTabType[]'
        }
      },
      rightSideControl: {
        defaultValue: null,
        description: 'Renders any content to the right of the tabs (playground toggle)',
        name: 'rightSideControl',
        parent: undefined,
        required: false,
        type: {
          name: 'ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}